import React from "react"

const Sellerextra = (props)=>{

const {sellerdata,setSellerData,val,user} = props

    return (
        <>
          <section>
          <table
            style={{
              width: 1100,
              margin: "0 auto",
              background: "#fff",
              padding: "10px 15px"
            }}
          >
            <tbody>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>
                        Section C. Title Conditions -
                      </span>
                      Do any of the following conditions exist with regard to the real
                      property?
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={4}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section C - Title Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  1. Any features, such as walls, fences and driveways
                                  which are shared?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  2. Any easements, other than normal utility
                                  easements?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  3. Any encroachments?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_3_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_3_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_3_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_3_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_3_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_3_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. Any zoning violations, non-conforming uses, or
                                  violations of “setback” requirements?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_4_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_4_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_4_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_4_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_4_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_4_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Any lot-line disputes?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_5_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_5_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_5_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_5_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_5_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_5_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Have you been notified, or are you aware of, any
                                  work planned or to be performed by a utility or
                                  municipality close to the real property including,
                                  but not limited to sidewalks, streets, sewers,
                                  water, power, or gas lines?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_6_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_6_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_6_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_6_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_6_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_6_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Any planned road or street expansions,
                                  improvements, or widening adjacent to the real
                                  property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_7_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_7_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_7_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_7_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_7_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_7_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. Any condominium, homeowners’, or other type of
                                  association which has any authority over the real
                                  property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_8_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_8_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_8_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_8_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_8_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_8_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  9. Any private transfer fee obligation upon sale?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_9_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_9_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_9_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_9_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_9_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_9_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={4}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section C - Title Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  10. Does ownership of the property entitle the owner
                                  to use any “common area” facilities such as pools,
                                  tennis courts, walkways, or other common use areas?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_10_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_10_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_10_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_10_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_10_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_10_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  11. Is there a common wall or walls?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_11_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_11_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_11_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_11_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_11_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_11_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is there a party wall agreement?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_11_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_11_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_11_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_11_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_11_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_11_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  12. Any lawsuits regarding this property during the
                                  ownership of the seller?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_12_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_12_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_12_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_12_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_12_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_12_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  13. Any notices from any governmental or quasi-
                                  governmental agency affecting the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_13_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_13_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_13_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_13_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_13_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_13_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  14. Any unpaid bills or claims of others for labor
                                  and/or materials furnished to or for the real
                                  property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_14_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_14_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_14_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_14_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_14_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_14_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  15. Any deed restrictions or other restrictions of
                                  record affecting the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_15_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_15_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_15_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_15_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_15_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_15_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  16. Any unsatisfied judgments against the seller?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_15_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_15_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_15_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_15_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_16_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_16_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  17. Any dispute regarding a right of access to the
                                  real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_17_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_17_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_17_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_17_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_17_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_17_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  18. Any other title conditions which might affect
                                  the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_18_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_18_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_18_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_18_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_c_18_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_c_18_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>
                        Section D. Other Conditions -
                      </span>
                      Do any of the following conditions exist with regard to the real
                      property?
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={5}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section D - Other Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. a. Are the dwelling(s) and the improvements
                                  connected to a public water system?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_1_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_1_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_1_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_1_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_1_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_1_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is the system operational?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_1_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_1_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_1_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_1_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_1_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_1_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  2. a. Are the dwelling(s) and the improvements
                                  connected to a private, community (non-public), or
                                  Sanitary Improvement District (SID) water system?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_2_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_2_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_2_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_2_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_2_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_2_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is the system operational?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_2_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_2_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_2_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_2_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_2_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_2_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  3. If the dwelling(s) and the improvements are
                                  connected to a private, community (non-public) or
                                  SID water system is there adequate water supply for
                                  regular household use (i.e. showers, laundry, etc.)?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_3_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_3_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_3_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_3_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_3_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_3_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. a. Are the dwelling(s) and the improvements
                                  connected to a public sewer system?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_4_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_4_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_4_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_4_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_4_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_4_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is the system operational?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_4_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_4_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_4_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_4_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_4_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_4_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. a. Are the dwelling(s) and the improvements
                                  connected to a community (non-public) or SID sewer
                                  system?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_5_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_5_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_5_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_5_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_5_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_5_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is the system operational?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_5_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_5_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_5_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_5_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_5_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_5_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. a. Are the dwelling(s) and the improvements
                                  connected to a septic system?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_6_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_6_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_6_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_6_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_6_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_6_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is the system operational?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_6_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_6_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_6_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_6_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_6_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_6_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Has the main sewer line from the house ever
                                  backed up or exhibited slow drainage?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_7_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_7_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_7_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_7_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_7_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_7_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={6}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section D - Other Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. a. Is the real property in a flood plain?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_8_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_8_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_8_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_8_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_8_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_8_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  b. Is the real property in a floodway?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_8_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_8_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_8_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_8_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_8_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_8_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  9. Is trash removal service provided to the real
                                  property? If so, are the trash services{" "}
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_9_1}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_9_1: !sellerdata?.section_d_9_1 }) }}
                                  />
                                  public <input type="checkbox"
                                    checked={sellerdata?.section_d_9_2}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_9_2: !sellerdata?.section_d_9_2 }) }}
                                  />
                                  private
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_9_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_9_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_9_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_9_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_9_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_9_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  10. Have the structures been mitigated for radon? If
                                  yes, when?{" "}
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 30
                                    }}
                                  />
                                  /
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 30
                                    }}
                                  />
                                  /
                                  <input
                                    type="text"
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 30
                                    }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_10_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_10_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_10_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_10_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_10_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_10_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  11. Is the property connected to a natural gas
                                  system?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_11_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_11_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_11_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_11_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_11_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_11_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  12. Has a pet lived on the property?{" "}
                                  <input
                                    type="text"
                                    value={sellerdata?.section_d_12_1}
                                    onChange={(e) => setSellerData({ ...sellerdata, section_d_12_1: e.target.value })}
                                    style={{
                                      outline: "none",
                                      border: "none",
                                      borderBottom: "1px solid black",
                                      width: 100
                                    }}
                                  />
                                  Type(s){" "}
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_12_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_12_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_12_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_12_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_12_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_12_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  13. Are there any diseased or dead trees, or shrubs
                                  on the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_13_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_13_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_13_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_13_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_13_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_13_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  14. Are there any flooding, drainage, or grading
                                  problems in connection to the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_14_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_14_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_14_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_14_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_14_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_14_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  15. a. Have you made any insurance or manufacturer
                                  claims with regard to the real property?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_15_1_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_15_1_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_15_1_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_15_1_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_15_1_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_15_1_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  b. Were all repairs related to the above claims
                                  completed?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_15_2_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_15_2_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_15_2_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_15_2_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_15_2_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_15_2_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  {" "}
                                  16. Are you aware of any problem with the exterior
                                  wall-covering of the structure including, but not
                                  limited to, siding, synthetic stucco, masonry, or
                                  other materials?
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_16_lst === "yes" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_16_lst: "yes" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_16_lst === "no" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_16_lst: "no" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_d_16_lst === "Do_Not_Know" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_d_16_lst: "Do_Not_Know" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>
                        Section E. Cleaning / Servicing Conditions -
                      </span>
                      Have you ever performed or had performed the following? (State
                      most recent year performed)
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", verticalAlign: "text-top" }}>
                          <table
                            // border={1}
                            cellPadding={3}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section E – Cleaning / Servicing Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YEAR</th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                                <th style={{ fontWeight: 600 }}>
                                  None / Not Included
                                </th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  1. Servicing of air conditioner
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_1_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_1_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_1_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_1_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_1_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_1_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_1_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_1_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  2. Cleaning of fireplace, including chimney
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_2_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_2_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_2_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_2_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_2_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_2_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_2_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_2_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  3. Cleaning of fireplace, including chimney
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_3_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_3_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_3_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_3_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_3_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_3_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_3_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_3_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  4. Servicing of furnace
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_4_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_4_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_4_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_4_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_4_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_4_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_4_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_4_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  5. Professional inspection of furnace A/C (HVAC)
                                  System
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_5_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_5_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_5_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_5_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_5_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_5_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_5_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_5_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  6. Professional inspection of furnace A/C (HVAC)
                                  System
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_6_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_6_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_6_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_6_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_6_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_6_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_6_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_6_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  7. Servicing of septic system
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_7_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_7_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_7_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_7_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_7_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_7_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_7_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_7_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td style={{ width: "50%", verticalAlign: "top" }}>
                          <table
                            // border={1}
                            cellPadding={10}
                            cellSpacing={0}
                            style={{ fontSize: 11, width: "100%" }}
                          >
                            <tbody>
                              <tr>
                                <th style={{ fontWeight: 600 }}>
                                  Section E – Cleaning / Servicing Conditions
                                </th>
                                <th style={{ fontWeight: 600 }}>YEAR</th>
                                <th style={{ fontWeight: 600 }}>YES</th>
                                <th style={{ fontWeight: 600 }}>NO</th>
                                <th style={{ fontWeight: 600 }}>Do Not Know</th>
                                <th style={{ fontWeight: 600 }}>
                                  None / Not Included
                                </th>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  8. Cleaning of wood-burning stove, including chimney
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_8_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_8_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_8_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_8_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_8_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_8_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_8_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_8_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  9. Treatment for wood-destroying insects or rodents
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_9_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_9_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_9_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_9_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_9_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_9_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_9_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_9_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  10. Tested well water
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_10_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_10_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_10_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_10_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_10_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_10_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_10_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_10_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td style={{ fontWeight: 600 }}>
                                  11. Serviced / treated well water
                                </td>
                                <td />
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_11_lst === "Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_11_lst: "Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_11_lst === "Not_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_11_lst: "Not_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_11_lst === "Do_Not_Know_If_Working" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_11_lst: "Do_Not_Know_If_Working" }) }}
                                  />
                                </td>
                                <td>
                                  <input type="checkbox"
                                    checked={sellerdata?.section_e_11_lst === "None" ? true : false}
                                    onChange={() => { setSellerData({ ...sellerdata, section_e_11_lst: "None" }) }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ marginTop: 5 }}>
                    <span style={{ fontWeight: 600 }}>
                      <span style={{ fontWeight: 700 }}>Seller’s Initials</span>
                      <input
                        type="text"
                        value={sellerdata?.seller_initial}
                        onChange={(e) => setSellerData({ ...sellerdata, seller_initial: e.target.value })}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      /
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />{" "}
                      Property Address{" "}
                      <input
                        value={sellerdata?.property_address}
                        onChange={(e) => setSellerData({ ...sellerdata, property_address: e.target.value })}
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 450
                        }}
                      />
                      Buyer’s Initials
                      <input
                        type="text"
                        value={sellerdata?.buyer_initial}
                        onChange={(e) => setSellerData({ ...sellerdata, buyer_initial: e.target.value })}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      /
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <table
            style={{
              width: 1100,
              margin: "0 auto",
              background: "#fff",
              padding: "10px 15px"
            }}
          >
            <tbody>
              <tr>
                <td>
                  <div>
                    <span>
                      <span style={{ fontWeight: 600 }}>PART III –</span>
                      Comments. Please reference comments on items responded to above
                      in PART I or II, with Section letter and item number. Note: Use
                      additional pages if necessary.
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span>
                    <input
                      type="text"
                      value={sellerdata?.comments}
                      onChange={(e) => setSellerData({ ...sellerdata, comments: e.target.value })}
                      style={{
                        outline: "none",
                        border: "none",
                        borderBottom: "1px solid black",
                        width: "100%"
                      }}
                    />
                  </span>
                </td>
              </tr>

              <tr>
                <td>
                  <div>
                    <span>
                      If checked here <input type="checkbox"
                        checked={sellerdata?.checked_here}
                        onChange={() => setSellerData({ ...sellerdata, checked_here: !sellerdata?.checked_here })}
                      />_ PART III is continued
                      on a separate page(s)
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ marginTop: 20, textAlign: "center" }}>
                    <span style={{ fontSize: 20, fontWeight: 600 }}>
                      SELLER’S CERTIFICATION
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div style={{ marginTop: 20 }}>
                    <span>
                      Seller hereby certifies that this disclosure statement, which
                      consists of
                      <input
                        type="text"
                        value={sellerdata?.consist_of}
                        onChange={(e) => setSellerData({ ...sellerdata, consist_of: e.target.value })}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 50
                        }}
                      />
                      pages (including additional comment pages), has been completed
                      by Seller; that Seller has completed this disclosure statement
                      to the best of Seller’s belief and knowledge as the date hereof,
                      which is the date this disclosure statement is completed and
                      signed by the Seller.
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tr>
                      <td>
                        Seller’s Signature
                        <img src={user === "seller" ? (val || sellerdata?.seller1_signature) : sellerdata?.seller1_signature} alt="" id="seller1_signature"
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid black",
                            width: 200
                          }}
                        />{" "}
                      </td>
                      <td>
                        Date{" "}
                        <input
                          type="date"
                          id="seller1_date"
                          value={sellerdata?.seller1_date ? sellerdata?.seller1_date : (user === "seller" && val || sellerdata?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}
                          onChange={(e) => setSellerData({ ...sellerdata, seller1_date: e.target.value })}
                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid black",
                            width: 200
                          }}
                        />
                      </td>
                    </tr>
                  </table>

                </td>
              </tr>
              <tr>
                <td>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        Seller’s Signature
                        <img src={sellerdata?.seller2_signature} alt="" id="seller2_signature"

                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid black",
                            width: 200
                          }}
                        />
                      </td>
                      <td style={{ paddingTop: "90px" }}>
                        Date{" "}
                        <input
                          type="date"
                          id="seller2_date"
                          value={sellerdata?.seller2_date}

                          style={{
                            outline: "none",
                            border: "none",
                            borderBottom: "1px solid black",
                            width: 200
                          }}
                        />
                      </td>
                    </tr>
                  </table>

                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: 10,
                      textAlign: "center",
                      marginTop: 20
                    }}
                  >
                    <span style={{ fontWeight: 600 }}>
                      ACKNOWLEDGEMENT OF RECEIPT OF DISCLOSURE STATEMENT,
                      UNDERSTANDING AND CERTIFICATION
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      border: "1px solid black",
                      padding: 10,
                      textAlign: "justify"
                    }}
                  >
                    <span style={{ fontWeight: 500 }}>
                      I/We acknowledge receipt of a photocopy of the above Seller
                      Property Condition Disclosure Statement; understand that such
                      disclosure statement is NOT a warranty of any kind by the seller
                      or any agent representing any principal in the transaction;
                      understand that such disclosure statement should not be accepted
                      as a substitute for any inspection or warranty that I/we may
                      wish to obtain; understand the information provided in this
                      disclosure statement is the representation of the seller and not
                      the representation of any agent, and is not intended to be part
                      of any contract between the seller and purchaser; and certify
                      that disclosure statement was delivered to me/us or my/our agent
                      on or before the effective date of any contract entered into by
                      me/us relating to the real property described in such disclosure
                      statement.
                      <br /> Purchaser’s Signature
                      <img
                        src={user === "client" ? (val || sellerdata?.purchaser1_signature) : sellerdata?.purchaser1_signature}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 100
                        }}
                      />{" "}
                      Date{" "}
                      <input
                        type="date"
                        value={sellerdata?.purchaser1_date ? sellerdata?.purchaser1_date : (user === "client" && val || sellerdata?.purchaser1_signature) ? new Date().toISOString().split('T')[0] : ""}
                        onChange={(e) => setSellerData({ ...sellerdata, purchaser1_date: e.target.value })}
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 200
                        }}
                      />
                      <br /> Purchaser’s Signature
                      <input
                        type="text"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 650
                        }}
                      />{" "}
                      Date{" "}
                      <input
                        type="date"
                        style={{
                          outline: "none",
                          border: "none",
                          borderBottom: "1px solid black",
                          width: 200
                        }}
                      />
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        </>
    )
}


export default Sellerextra